import { createApiService } from "../http";
import { BaseRequest } from "../types/services-types/http-types";
import { IProgrammMinfin } from "../types/services-types/programms-minfin";

export default class ProgrammMinfinService {

    static apiProgrammMinfinService = createApiService('/minfin-programms')

    static async GetAll() {
        const response = await this.apiProgrammMinfinService.get<IProgrammMinfin[]>('/all')
        return response.data
    }
}